export const HAKLAI_PROPERTY_PART_LABELS = Object.freeze({
  sectionTitle: "מרכיבי הנכס",
  yes: "כן",
  no: "לא",
  emptySection: "לא נוספו בתי מגורים",
  farmAssets: "רכיב נכס",
  relativeSaleValue: "שווי יחסי מהמכירה",
  builtValue: "שווי החלק הבנוי",
  zabanValue: 'שווי זב"ן',
  requestedPtor: "פטור מבוקש",
  rentalDepreciation: "האם הושכר?",
  sectionA: "מגורים מזכה",
  residential: "מגורים מזכה",
  farmRemainderSection: "נכסים נוספים במשק",
  farmRemainder: "יתרת המשק",
  noFarmRemainder: "אין יתרה",
  saleValuePlaceholder: "הזן סכום",
  builtValuePlaceholder: "הזן שווי בנוי",
  zabanValuePlaceholder: 'הזן שווי זב"ן',
  notRelevantInSection: "לא רלוונטי בסעיף זה",
  notRelevantWithoutZaban: 'לא רלוונטי ללא זב"ן',
  zabanNotSelected: 'זב"ן לא סומן במשק',
  pre1997ConstructionQuestion: "הבנייה הסתיימה לפני 1.4.1997?",
  noExemption: "ללא פטור",
  singleApartmentExemption: "פטור דירה יחידה",
  inheritanceExemption: "פטור ירושה",
  tzinunQuestion: "מגבלת צינון לדירה",
  tzinunApartmentQuestion: "האם קיימת מגבלת צינון על הדירה?",
  tzinunCheckPrompt: "לא בטוחים אם קיימת מגבלת צינון?",
  checkTzinunEligibility: "לחצו כאן לבדיקה",
  approve: "אישור"
});

export const HAKLAI_PROPERTY_PART_TOOLTIPS = Object.freeze({
  zabanValueForResidence: 'שווי זכויות הבנייה בבית מגורים זה. ריק או 0 אם אין זב"ן',
  farmRemainderInvalid: "סך שווי בתי המגורים גבוה משווי המכירה הכולל",
  deletePart: "מחיקת רכיב נכס",
  rentalDepreciationForPart: "פחת בשכירות לרכיב הנכס",
  requestedPtorForPart: "בחירת הפטור המבוקש עבור בית מגורים זה. ניתן לבחור פטור אחד בלבד בכל הטבלה"
});

export const HAKLAI_PROPERTY_PART_ERRORS = Object.freeze({
  missingAnyPart: "יש להזין לפחות חלק אחד בנכס",
  missingPrimaryResidenceValue: "יש להזין שווי לבית המגורים הראשי",
  missingPartValue: "יש להזין שווי לכל חלק",
  missingRelevantBuiltValue: "יש להזין את שווי החלק הבנוי לכל חלק מגורים רלוונטי",
  invalidRelevantBuiltValue: "יש להזין שווי חלק בנוי תקין לכל חלק מגורים",
  builtValueGreaterThanPartValue: "שווי החלק הבנוי לא יכול להיות גדול משווי החלק",
  zabanRequired: 'יש להזין שווי זב"ן לבית מגורים זה',
  zabanInvalid: 'יש להזין שווי זב"ן תקין',
  zabanNeedsSaleValue: 'יש להזין שווי יחסי מהמכירה לפני שווי הזב"ן',
  zabanMustBeLowerThanSale: 'שווי הזב"ן חייב להיות נמוך משווי החלק במכירה',
  valueOvershoot: "שווי זה חורג מסך שווי המכירה",
  builtValueExceedsPartValue: "שווי החלק הבנוי גבוה משווי החלק",
  required: "שדה חובה"
});

export const getHaklaiPropertyPartAddAriaLabel = (sectionTitle, canAdd) => (
  canAdd
    ? `הוסף רכיב ל${sectionTitle}`
    : `לא ניתן להוסיף רכיב נוסף ל${sectionTitle}`
);
